<template>
  <v-card class="pa-4">
    <h3>{{ label }}</h3>

    <v-row align="center" v-if="editProp">

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="ValueSifirla">
            <v-icon>mdi-playlist-minus</v-icon>
          </v-btn>
        </template>
        <span>Değerleri Temizle</span>
      </v-tooltip>

    </v-row>

    <!-- <h3>{{ label }}</h3>
   <v-spacer></v-spacer>      <v-btn icon @click="ValueSifirla">
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
    <div v-if="disable" style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında
        görüntülenmeyecektir. </span></div>
    <v-simple-table>
      <thead>
        <tr>
          <th></th>
          <th v-if="KolonType.LikertYildiz != kolonTipi" v-for="col in columns" :key="col.name" class="text-center">
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in listRows" :key="row.id" :class="row.disable === true ? 'disabled' : ''">
          <td>{{ row.name }}</td>

            <td v-if="KolonType.LikertYildiz != kolonTipi" v-for="col in columns" :key="'radio-' + col.name" class="text-center" style="vertical-align: middle;">
        <v-radio-group v-model="row.value" row hide-details>
          <v-radio :value="col.name" color="primary"></v-radio>
        </v-radio-group>
      </td>

      <!-- Yıldız Tipi (Döngüsüz, Tek bir td) -->
      <td v-if="KolonType.LikertYildiz == kolonTipi"  class="text-center" style="vertical-align: middle;">
        <v-rating :length="yildizAdet" size="32" v-model="row.value"></v-rating>
      </td>
    
          <!-- <td v-if="KolonType.LikertYildiz!=kolonTipi" v-for="col in columns" :key="col.name" class="text-center" style="vertical-align: middle;">
            <v-radio-group v-model="row.value" row hide-details>
              <v-radio :value="col.name" color="primary"></v-radio>
            </v-radio-group>
          </td> -->
          <!-- <td>
            <v-rating length="5" size="32" :value="row.value"></v-rating>
          </td> -->

        </tr>
      </tbody>
    </v-simple-table>

    <v-checkbox v-model="valid" v-show="false" :rules="listRules2()"></v-checkbox>

    <div style="color:red;" v-if="!valid">
      Lütfen boş soru bırakmayınız.
    </div>



  </v-card>
</template>

<script>
import { radioMatrixSF } from '@/plugins/FieldDataFormat.js'
import { KolonType } from '@/plugins/Enum';
export default {
  name: "MultipleRadioGridEditor",
  data() {
    return {
      KolonType:KolonType,
      valid: true,
      id: "",
      value: [],
      label: "",
      required: false,
      color: null,
      disable: false,
      hint: "",
      items: [],
      rows: [],
      columns: [],
      kolonTipi:1,
yildizAdet:5,

      // rules: [v => !!v || 'Name is required'],
      placeholder: "",


    }
  },
  props: {
    editProp: {
      default: false,
      type: Boolean
    },
    ayar: {
      default() {
        return radioMatrixSF;
      },
      type: Object
    },
    rules: {
      default() {
        return [v => !!v || 'Name is required'];
      },
      type: Array

    }

  },
  computed: {
    listRows() {
      //console.log("listRows,", this.rows);
      if (this.editProp) {

        return this.rows;
      }
      else {
        return this.rows.filter(m => m.disable === false);
      }

    }

  },
  methods: {
    ValueSifirla() {
      this.rows.forEach(element => {
        element.value = null;
      });
    },
    listRules2() {

      if (this.ayar.required) {
        this.valid = this.rows.every(m => !!m.value);
      }
      else {
        this.valid = true;
      }

      return [v => this.valid || 'Bu alan zorunludurx']
    },
    dataBind(json) {
      //console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.title = json.title;

      // this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.required = json.required;
if ("kolonType" in json) {
 
  this.kolonTipi=json.kolonType;
  
}
if ("yildizAdet" in json) {
 
  this.yildizAdet=json.yildizAdet;

}
      this.disable = json.disable;
      this.id = json.id;
      for (let index = 0; index < json.rows.length; index++) {
        const element = json.rows[index];
        if (!("disable" in element)) {
          element.disable = false;
        }

      }

      this.rows = json.rows;
      this.columns = json.columns
      this.header = json.header;
      // this.value=  json.value.lenght>0 ? json.value.split(',') : [];
      // this.value=  json.value;

    }
  },
  created() {
    this.dataBind(this.ayar);
    //console.log("Created Value:",this.ayar.value.length);
    //this.value=  this.ayar.value.length>0 ? this.ayar.value.split(',') : [];
  },
  watch: {


    value(x, y) {
      this.$emit('input', x);
      //console.log("Rules",x,y);
    },
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
        // console.log("handler:",newVal);
        // if  (newVal.required){
        // newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
        // }

        this.dataBind(newVal);
        //this.slots.forEach(slot => {
        //    if (slot.availability > 10) slot.availability = 10;
        //});
      },
      deep: true
    }

  },
};
</script>
<style scoped>
::v-deep .v-input--radio-group__input {
  display: block;
  text-align: center;
}

::v-deep .v-radio {
  align-items: center;
  display: block;
  height: auto;
  outline: none;
}

.vertical-header {
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  text-align: center;
  white-space: nowrap;
  height: 150px;
}

.disabled {
  opacity: 0.5;
  background: gray;
  pointer-events: none;
  user-select: none;
}
</style>